const routes = {
  shifts: 'שעות עבודה',
  passengers: 'עובדים'
};

export default routes;
